const ONE_DAY_MS = 24 * 60 * 60 * 1000;

const key = (userId: string, programId: string) =>
  `enrolment_requested_${userId}_${programId}`;

export const hasEnquired = (userId: string, programId: string): boolean => {
  if (!userId || !programId) return false;
  const ts = localStorage.getItem(key(userId, programId));
  return !!ts && Date.now() - Number(ts) < ONE_DAY_MS;
};

export const markEnquired = (userId: string, programId: string): void => {
  if (!userId || !programId) return;
  localStorage.setItem(key(userId, programId), String(Date.now()));
};
